import { Modal, Grid, Text, Alert } from '@simplywallst/ui-core';

import type { Holding } from '@/hooks/portfolio/usePortfolio';

import { useRemoveManualHolding } from '../../../PortfolioManual';

interface Props {
  holding: Holding;
  onSuccess: () => void;
  onCancel: () => void;
}

export const RemoveManualPortfolioHoldingModal = ({
  holding,
  onCancel,
  onSuccess,
}: Props) => {
  const { mutate, status, error } = useRemoveManualHolding({
    onSuccess,
  });
  return (
    <Modal
      data-cy-id="remove-manual-portfolio-holding-confirmation-modal"
      title={`Removing ${holding.company.tickerSymbol}`}
      primaryLabel={`Remove ${holding.company.tickerSymbol}`}
      onPrimaryClick={() => mutate({ id: holding.id })}
      primaryLoading={status === 'pending'}
      secondaryLabel="Cancel"
      onSecondaryClick={onCancel}
      disabled={status === 'pending'}
    >
      <Grid gap="16px">
        {status === 'error' && (
          <Alert styleType="negative">{(error as Error)?.message}</Alert>
        )}
        <Text typography="small" color="spaceGray">
          You're about to remove {holding.company.tickerSymbol} from this
          portfolio.
        </Text>
        <Text typography="small" color="spaceGray">
          Are you sure?
        </Text>
      </Grid>
    </Modal>
  );
};
